@if (titles() && titles().length) {
  @for (title of titles(); track title; let first = $first) {
    @if (title.text; as text) {
      @switch (title.level) {
        @case ("H1") {
          <h1
            [innerHTML]="text"
            [ngClass]="title | getClass: breakpoints()"
            [style.font-size]="title | fontSize: breakpoints()"
            [style.font-weight]="title.weight"
            [style.margin-top]="title.space ? title.space : 0"
            class="title"></h1>
        }
        @case ("H2") {
          <h2
            [innerHTML]="text"
            [ngClass]="title | getClass: breakpoints()"
            [style.font-size]="title | fontSize: breakpoints()"
            [style.font-weight]="title.weight"
            [style.margin-top]="title.space ? title.space : 0"
            class="title"></h2>
        }
        @case ("H3") {
          <h3
            [innerHTML]="text"
            [ngClass]="title | getClass: breakpoints()"
            [style.font-size]="title | fontSize: breakpoints()"
            [style.font-weight]="title.weight"
            [style.margin-top]="title.space ? title.space : 0"
            class="title"></h3>
        }
        @case ("H4") {
          <h4
            [innerHTML]="text"
            [ngClass]="title | getClass: breakpoints()"
            [style.font-size]="title | fontSize: breakpoints()"
            [style.font-weight]="title.weight"
            [style.margin-top]="title.space ? title.space : 0"
            class="title"></h4>
        }
        @case ("H5") {
          <h5
            [innerHTML]="text"
            [ngClass]="title | getClass: breakpoints()"
            [style.font-size]="title | fontSize: breakpoints()"
            [style.font-weight]="title.weight"
            [style.margin-top]="title.space ? title.space : 0"
            class="title"></h5>
        }
        @case ("H6") {
          <h6
            [innerHTML]="text"
            [ngClass]="title | getClass: breakpoints()"
            [style.font-size]="title | fontSize: breakpoints()"
            [style.font-weight]="title.weight"
            [style.margin-top]="title.space ? title.space : 0"
            class="title"></h6>
        }
        @default {
          <span
            [innerHTML]="text"
            [ngClass]="title | getClass: breakpoints()"
            [style.font-size]="title | fontSize: breakpoints()"
            [style.font-weight]="title.weight"
            [style.margin-top]="title.space ? title.space : 0"
            class="title"></span>
        }
      }
    }
  }
}
